export default "__VITE_ASSET__BfHW_eOK__"